module.exports = __webpack_public_path__ + "img/cc.086442ca.jpg";